import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaUserCircle } from "react-icons/fa"; // Importing the profile icon
import CityList from "../CityList/CityList";
import { main_logo, white_logo } from "../../Utils/export";
import { getUserData } from "../../Utils/localStorageUtils";
import useUserLocation from "../../hooks/useUserLocation";
import { setLocation, updateCity } from "../../Redux/slices/locationSlice";
import { useDispatch, useSelector } from "react-redux";
import useCustomNavigate from "../../hooks/useCustomNavigate";

function Navbar({ setNavbarHeight }) {
  const dispatch = useDispatch()

  const { goToNewTab } = useCustomNavigate()

  const locationPath = useLocation().pathname;
  const isHome = locationPath === "/";


  const { location, error, fetchLocation } = useUserLocation();
  const [showCityList, setShowCityList] = useState(false);
  const [selectedCity, setSelectedCity] = useState("New Delhi");  // Default city
  const [menuOpen, setMenuOpen] = useState(false);

  const [isScrolled, setIsScrolled] = useState(false);


  console.log("selectedCity", selectedCity)

  const navbarRef = useRef(null);
  const navigate = useNavigate(); // For navigation to /profile
  const isLogin = getUserData();
  console.log("locationlocation", location)
  // Fetch location on component mount
  useEffect(() => {
    fetchLocation();
  }, []);


  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const locationData = queryParams.get('location'); // Get the 'location' query parameter
    console.log("locationData", locationData, location)
    // Check if locationData exists in the URL and parse it
    if (locationData) {
      const decodedLocation = JSON.parse(decodeURIComponent(locationData)); // Decode and parse the location data
      const cityFromUrl = decodedLocation?.city; // Extract the city from the decoded location

      // If city data exists in the URL, set the selected city
      if (cityFromUrl) {
        setSelectedCity(cityFromUrl);
      } else if (location?.city) {
        // If URL doesn't have city, fall back to location from useUserLocation
        setSelectedCity(location.city);
      }
    } else if (location?.city) {
      // If no locationData in URL, fall back to location from useUserLocation
      setSelectedCity(location.city);
      dispatch(setLocation(location))
    }
  }, [location]); // Run this effect once when component mounts and when location changes


  useEffect(() => {
    if (navbarRef.current) {
      // Pass the height of the Navbar to the SubNavBar
      setNavbarHeight && setNavbarHeight(navbarRef.current.offsetHeight);
    }
  }, [setNavbarHeight]);

  // Handle city selection from CityList
  const handleCitySelect = (city) => {
    setSelectedCity(city);
    setShowCityList(false); // Close city list after selection
    console.log("citycitycity", city);

    dispatch(updateCity(city))
  };


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  const navbarClasses = `fixed top-0 left-0 w-full border-b z-[99] h-[74px] transition-all duration-300 ${isHome
    ? isScrolled
      ? "bg-white/60 backdrop-blur-md shadow-md border-gray-300"
      : "shadow-none border-gray-300"
    : "bg-white/60 backdrop-blur-md shadow-md border-gray-300"
    }`;

  const cityTextClasses = `relative hidden md:flex items-center gap-1 font-bold text-lg cursor-pointer transition duration-150 ${isHome
    ? isScrolled
      ? "text-black"
      : "text-white"
    : "text-black"
    }`;



  return (
    <div
      className={navbarClasses}
    >
      <div
        ref={navbarRef}
        className="flex  justify-between px-4 py-2"
      >
        {/* Left Section: Logo and City */}
        <div className="flex gap-6">
          <div className="flex items-center">
            <div className="h-14 w-14 flex items-center justify-center">
              <Link to="/" className="block">
                <img
                  src={isHome ? isScrolled ? main_logo : white_logo : main_logo}
                  loading="lazy"
                  alt="Logo"
                  className="h-full w-full object-contain"
                />
              </Link>
            </div>
          </div>

          <div
            className={cityTextClasses}
            onMouseEnter={() => setShowCityList(true)}
            onMouseLeave={() => setShowCityList(false)}
          >
            <p className="transition duration-150 ease-in-out">{selectedCity}</p>
            <span className="text-sm">&#9660;</span>

            {showCityList && (
              <div className="absolute left-0 top-full bg-white shadow-lg rounded-md">
                <CityList onCitySelect={handleCitySelect} />
              </div>
            )}
          </div>
        </div>




        {/* Right Section: Menu Icon for Mobile & Full Nav for Desktop */}
        <div className="flex items-center">
          <button
            className="block md:hidden text-xl"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <FaBars />
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/bankaunction"
              className="px-3 py-1 bg-gray-200 rounded-full text-sm hover:bg-gray-400 transition"
            >
              Bank Auction
            </Link>

            {/* Post Property Dropdown */}
            <div className="relative group">
              <button className="px-3 py-1 bg-gray-200 rounded-full text-sm hover:bg-gray-400 transition">
                Post
              </button>
              <div className="absolute right-0 top-full mt-2 bg-white shadow-lg rounded-md w-[140px] hidden group-hover:block">
                <div className="absolute right-0 transform -translate-x-1/2 -top-2 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-black font-medium"></div>

                <Link
                  to="/addproperty"
                  className="block px-4 py-1 hover:bg-[#00274D] hover:text-white"
                >
                  Property
                </Link>
                <Link
                  to="/addproject"
                  className="block px-4 py-1 hover:bg-[#00274D] hover:text-white"
                >
                  Project
                </Link>
              </div>
            </div>

            {/* Profile or Login Button */}
            {isLogin ? (
              <FaUserCircle
                className={`text-3xl cursor-pointer hover:text-blue-800 ${isHome ? (isScrolled ? "text-black" : "text-white") : "text-black"
                  }`}
                onClick={() =>
                  goToNewTab("https://one-two-one-admin-panel.vercel.app")
                }
              />
            ) : (
              <Link
                to="/login"
                className="px-4 py-1 bg-[#007BFF] text-white rounded-full hover:bg-blue-800 transition"
              >
                Login
              </Link>
            )}
          </div>
        </div>

      </div>
      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden flex flex-col items-start bg-white border-t p-4 ">
          <div
            className="relative flex items-center text-lg font-bold text-[#333333] cursor-pointer w-full"
            onClick={() => setShowCityList(!showCityList)}
          >
            {selectedCity} <span className="text-sm ml-2">&#9660;</span>
            {showCityList && (
              <div className="absolute left-0 top-full bg-white shadow-lg rounded-md w-40 mt-2">
                <CityList onCitySelect={handleCitySelect} />
              </div>
            )}
          </div>

          <Link
            to="/bankaunction"
            className="block w-full py-2 mt-2 text-[#333] hover:bg-gray-200 rounded"
          >
            Bank Auction
          </Link>

          <div className="relative group w-full">
            <button className="w-full text-left py-2 mt-2 text-[#333] hover:bg-gray-200 rounded">
              Post
            </button>
            <div className="absolute left-0 top-full bg-white shadow-lg rounded-md w-full hidden group-hover:block">
              <Link
                to="/addproperty"
                className="block px-4 py-2 hover:bg-[#00274D] hover:text-white"
              >
                Property
              </Link>
              <Link
                to="/addproject"
                className="block px-4 py-2 hover:bg-[#00274D] hover:text-white"
              >
                Project
              </Link>
            </div>
          </div>

          {isLogin ? (
            <FaUserCircle
              className="text-3xl text-white cursor-pointer  mt-3"
              onClick={() =>
                goToNewTab("https://one-two-one-admin-panel.vercel.app")
              }
            />
          ) : (
            <Link
              to="/login"
              className="block w-full py-2 mt-2 bg-[#800000] text-white text-center rounded-md hover:bg-blue-800 transition"
            >
              Login
            </Link>
          )}
        </div>
      )}

    </div>
  );
}

export default Navbar;
